import React, { createContext, useContext, ReactNode } from 'react';
import { Site } from './types';

const SiteContext = createContext<Site | null>(null);

export function SiteProvider({ site, children }: { site: Site; children: ReactNode }) {
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export function useSite(): Site {
  const site = useContext(SiteContext);

  if (!site) {
    throw new Error('useSite() called outside of a <SiteProvider>');
  }

  return site;
}
